angular.module('autoremind.templates')
    .directive('adminTemplatesAll', ['logger', 'dialogs', 'templateService', '$timeout', 'userSettings', 'eventSharingService',
    function (logger, dialogs, templateService, $timeout, userSettings, eventSharingService) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/admin-templates-all.html',
            scope: {
                userId: '='
            },
            link: function ($scope, element, attrs) {
                $scope.templateService = templateService;
                $scope.userSettings = userSettings;
                $scope.canEditDefault = eventSharingService.hasPermission(['admin:template:editdefault']);
                element.addClass('adminTemplatesAll');
                $scope.viewModel = {
                    selectedType: 'communication',
                    userType: 'users',
                    messagesSort: { column: "createdInt", descending: true },
                    currentTemplate: null,
                    selectedTemplate: null,
                    editableColumn: null
                };
                $scope.$watch('userId', function (newVal, oldVal) {
                    console.log('filterWasChanged', newVal, oldVal);
                    $scope.filterWasChanged(true);
                });
                $scope.messageDataFilter = function (messageData) {
                    if (userSettings.model.ar3filters.category === 'all' || userSettings.model.ar3filters.category === '')
                        return true;
                    return messageData.communicationsCategoryId === userSettings.model.ar3filters.category;
                };
                $scope.changeSorting = function (column) {
                    if (userSettings.model.ar3filters.sortby === column) {
                        userSettings.model.ar3filters.order = !userSettings.model.ar3filters.order;
                    }
                    else {
                        userSettings.model.ar3filters.sortby = column;
                        userSettings.model.ar3filters.order = false;
                    }
                    $scope.filterWasChanged(true);
                };
                var _timeout;
                $scope.filterWasChanged = function (isNoNeedTimeout, category) {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    if (isNoNeedTimeout) {
                        _timeout = null;
                        $scope.templateService.resetFilters();
                        return;
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        $scope.templateService.resetFilters();
                    }, 1000);
                };
                $scope.enabledFeaturesFilter = function (item) {
                    return $scope.templateService.enabledFeaturesFilter(item);
                };
                /** TODO: These should be disabled when changing other filters? */
                $scope.hidingFilter = function (template) {
                    return $scope.templateService.hidingFilter(template);
                };
                $scope.editTemplatef = function () {
                    var dialog = dialogs.create('app/admin/templates/admin-templates.change.dialog.first.html', 'autoremind.templates.editDialogController', {}, { key: false, back: 'static', windowClass: 'templatesEditDialog' });
                    dialog.result
                        .then(function () {
                    }, function () {
                    });
                };
                $scope.editTemplates = function () {
                    var dialog = dialogs.create('app/admin/templates/admin-templates.change.dialog.second.html', 'autoremind.templates.editDialogController', {}, { key: false, back: 'static', windowClass: 'templatesEditDialog' });
                    dialog.result
                        .then(function () {
                    }, function () {
                    });
                };
                $scope.loadTemplates = function () {
                    console.log('loadTemplates');
                    $scope.templateService.getTemplates();
                };
                $scope.changeTemplate = function (template) {
                    if (template.editingTemplate) {
                        return;
                    }
                    $timeout(function () {
                        if (template.templateDisplayName === '') {
                            $scope.showMessageIfEditedFieldIsEmpty(template, angular.copy($scope.templateService.model.currentTemplate), 'templateDisplayName');
                            return;
                        }
                        if (template.templateFileRef === '') {
                            $scope.showMessageIfEditedFieldIsEmpty(template, angular.copy($scope.templateService.model.currentTemplate), 'templateFileRef');
                            return;
                        }
                        //                console.log('template', template, $scope.templateService.model.currentTemplate)
                        $scope.templateService.changeTemplate(template, angular.copy($scope.templateService.model.currentTemplate));
                    }, 50);
                    $scope.viewModel.editableColumn = null;
                };
                $scope.showMessageIfEditedFieldIsEmpty = function (template, oldTemplate, field) {
                    var msg = '';
                    var column = '';
                    switch (field) {
                        case 'templateDisplayName':
                            msg = 'You need to enter a name for the template.';
                            column = 'name';
                            break;
                        case 'templateFileRef':
                            column = 'filename';
                            msg = 'You need to enter a file name for the template.';
                            break;
                    }
                    $scope.viewModel.editableColumn = column;
                    dialogs.confirm('Warning', msg)
                        .result.then(function () {
                    }, function () {
                        template.isEdited = false;
                        template[field] = oldTemplate[field];
                    });
                };
                $scope.changeTemplateMaster = function (template) {
                    $scope.selectTemplate(template);
                    $timeout(function () {
                        $scope.templateService.model.currentTemplate.isSystemMaster = !template.isSystemMaster;
                        $scope.changeTemplate(template);
                    }, 50);
                };
                $scope.changeTemplateIsConfirm = function (template) {
                    $scope.selectTemplate(template);
                    $timeout(function () {
                        $scope.templateService.model.currentTemplate.isConfirm = !template.isConfirm;
                        $scope.changeTemplate(template);
                    }, 50);
                };
                $scope.changeTemplateField = function (template, field) {
                    if (!template.isEdited) {
                        return;
                    }
                    $scope.changeTemplate(template);
                };
                $scope.openFieldToEdit = function (template, column) {
                    $scope.viewModel.editableColumn = column;
                };
                $scope.selectTemplate = function (template, column) {
                    //                console.log('selectTemplate');
                    $timeout(function () {
                        if (($scope.canEditDefault || template.countOfMappings === 0) &&
                            $scope.templateService.model.currentTemplate &&
                            $scope.templateService.model.currentTemplate.templateId === template.templateId) {
                            $scope.viewModel.editableColumn = column;
                        }
                        else {
                            $scope.viewModel.editableColumn = null;
                        }
                        if ($scope.templateService.model.currentTemplate && $scope.templateService.model.currentTemplate.templateId === template.templateId) {
                            return;
                        }
                        if ($scope.viewModel.selectedTemplate && $scope.viewModel.selectedTemplate.isEdited) {
                            $scope.changeTemplate($scope.viewModel.selectedTemplate);
                            return;
                        }
                        $scope.templateService.model.currentTemplate = angular.copy(template);
                        $scope.templateService.clonedTemplateModel = null;
                        $scope.viewModel.selectedTemplate = template;
                    });
                };
                $scope.cancelEditing = function (template, column) {
                    $scope.viewModel.editableColumn = null;
                    template[column] = $scope.templateService.model.currentTemplate[column];
                    template.isEdited = false;
                };
                $scope.cloneTemplate = function (template) {
                    $scope.templateService.cloneTemplate(template.templateId)
                        .then(function (res) {
                        console.log('templateCloned', res);
                        if (angular.isDefined(res.templateCloned) && angular.isDefined(res.templateCloned.templateId)) {
                            res.templateCloned.countOfMappings = 0;
                            $scope.templateService.model.autoremind3.templates.push(res.templateCloned);
                            $scope.selectTemplate(res.templateCloned, 'name');
                            $scope.selectTemplate(res.templateCloned, 'name');
                        }
                    }, function (err) {
                        console.log('templateCloned', err);
                    });
                };
                $scope.upload = function (template) {
                    $scope.selectTemplate(template);
                    if (template.countOfTemplateFileUsages && template.countOfTemplateFileUsages > 0) {
                        $scope.templateService.showErrorIfFileIsUsed()
                            .then(function () {
                            $scope.uploadTemplate(template, true);
                        });
                        return;
                    }
                    $scope.uploadTemplate(template);
                };
                $scope.uploadTemplate = function (template, isCustomTemplate) {
                    $scope.templateService.uploadTemplate(template, isCustomTemplate)
                        .then(function () {
                        // $scope.filterWasChanged(true);
                    });
                };
                $scope.editTemplateModelDialog = function (template) {
                    console.log('editTemplateModelDialog', template);
                    $scope.selectTemplate(template, 'name');
                    console.log($scope.canEditDefault);
                    $scope.templateService.editTemplateModelDialog(template, undefined, false, true);
                };
                $scope.getFocus = function () {
                    return true;
                };
                /**
                 * Logical rules of filters interaction
                 */
                $scope.$watch('userSettings.model.ar3filters.displayDefault', function (newVal, oldVal) {
                    if (newVal === true) {
                    }
                });
                $scope.$watch('userSettings.model.ar3filters.hideOtherUsersTemplates', function (newVal, oldVal) {
                    if (newVal === true) {
                        userSettings.model.ar3filters.displayDefault = false;
                    }
                });
                $scope.$watch('userSettings.model.ar3filters.hideAssignedTemplates', function (newVal, oldVal) {
                    if (newVal === true) {
                        userSettings.model.ar3filters.displayDefault = false;
                    }
                    if (newVal === true && userSettings.model.ar3filters.hideNotMappedForCurrent === true) {
                        userSettings.model.ar3filters.hideOtherUsersTemplates = false;
                        // userSettings.model.ar3filters.hideLinkedAnyUsers = false;
                        userSettings.model.ar3filters.hideNotMappedForCurrent = false;
                    }
                    if (newVal === true && userSettings.model.ar3filters.hideLinkedAnyUsers === true) {
                        userSettings.model.ar3filters.hideLinkedAnyUsers = false;
                    }
                });
                $scope.$watch('userSettings.model.ar3filters.hideNotMappedForCurrent', function (newVal, oldVal) {
                    if (newVal === true) {
                        userSettings.model.ar3filters.displayDefault = false;
                    }
                    if (newVal === true && userSettings.model.ar3filters.hideAssignedTemplates === true) {
                        userSettings.model.ar3filters.hideOtherUsersTemplates = false;
                        userSettings.model.ar3filters.hideLinkedAnyUsers = false;
                        userSettings.model.ar3filters.hideAssignedTemplates = false;
                    }
                });
                $scope.$watch('userSettings.model.ar3filters.hideLinkedAnyUsers', function (newVal, oldVal) {
                    if (newVal === true) {
                        userSettings.model.ar3filters.displayDefault = false;
                    }
                    if (newVal === true && userSettings.model.ar3filters.hideAssignedTemplates === true) {
                        userSettings.model.ar3filters.hideAssignedTemplates = false;
                    }
                });
            }
        };
    }])
    .directive('scrolly', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var raw = element[0];
            element.bind('scroll', function () {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                    scope.$apply(attrs.scrolly);
                }
            });
        }
    };
});
//# sourceMappingURL=admin-templates-all.js.map